import Component from 'gia/Component';

import { gsap } from "gsap";


export default class OffreToggle extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      offreTitles: [],
      pills: [],
      toggles: []
    };
  }

  mount() {
    let that = this;

    this.ref.toggles.forEach(function(toggle, index) {

      toggle.addEventListener('click', function(e) {
        if (toggle.classList.contains('active')) {
          that.closeToggle(index);
        } else {
          that.ref.toggles.forEach(function(toggle, index) {
            if (toggle.classList.contains('active')) {
              that.closeToggle(index);
            }
          })
          that.openToggle(index);
        }
      })
    });
  }

  closeToggle(index) {
    let that = this;
    let title = that.ref.offreTitles[index];
    let color = title.dataset.color;
    let pill = that.ref.pills[index];
    let toggle = this.ref.toggles[index];
    toggle.classList.remove('active');
    let timeline = gsap.timeline();
    timeline.to(pill, {right: '96px', width: 67, backgroundColor: color, duration: 0.5});
    timeline.to(toggle, {backgroundColor: '#F0F0F0', borderColor: 'black'}, '-=0.5');
  }

  openToggle(index) {
    let that = this;
    let title = that.ref.offreTitles[index];
    let color = title.dataset.color;
    let pill = that.ref.pills[index];
    let toggle = this.ref.toggles[index];
    toggle.classList.add('active');
    let timeline = gsap.timeline();
    timeline.to(pill, {right: '2px', width: title.offsetWidth + 14, backgroundColor: '#F0F0F0', duration: 0.5});
    timeline.to(toggle, {backgroundColor: color, borderColor: color}, '-=0.5');
  }

}